import { PATIENT_NARRATIVE_WIZARD_SECTION_TITLES } from "./patientNarrativeWizardSections";

/**
 * Turns a failed GET/PATCH into a message safe to show the user, following
 * the same shape of check already used across the CSR/PN pages
 * (`pn/Summary.js`, `pn/FileUpload.js`): no response vs. 401 vs. 400
 * (structural validation) vs. everything else.
 */
export function describeSaveError(err) {
  if (!err?.response) {
    return "No Server Response";
  }
  // A wizard 422 carries the backend's validation message as a string; the
  // framework's own 422 (bad section name / non-object body) carries an
  // array, which is not meant for the user.
  if (err.response.status === 400 || err.response.status === 422) {
    const detail = err.response.data?.detail;
    return typeof detail === "string" && detail
      ? detail
      : "Please check your answers and try again.";
  }
  if (err.response.status === 401) {
    return "Invalid user credentials";
  }
  return "Failed to save your answers.";
}

export function describeLoadError(err) {
  if (!err?.response) {
    return "No Server Response";
  }
  if (err.response.status === 401) {
    return "Invalid user credentials";
  }
  return "Failed to load this section.";
}

/**
 * The message for a 409 from POST /patient-narratives/{id}/generation. The
 * body is `{ detail: { error, missing: { <section>: [{ field, code }] } } }`;
 * the sections still to finish are named so the user knows where to go.
 */
export function describeGenerationConflict(data) {
  const detail = data?.detail;
  if (typeof detail === "string" && detail) return detail;
  const message = detail?.error || "Narratives can't be generated yet.";
  const sections = Object.keys(detail?.missing || {}).map(
    section => PATIENT_NARRATIVE_WIZARD_SECTION_TITLES[section] || section
  );
  return sections.length
    ? `${message} Still to complete: ${sections.join(", ")}.`
    : message;
}
